import {
  discountRuleConditionsSchema,
  discountRuleTypeConfigSchema,
  discountValueSchema,
  MAX_DISCOUNT_MESSAGE_LENGTH,
} from "@redotech/redo-model/discount-rules/discount-rule";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateDiscountRule = {
  name: "updateDiscountRule" as const,
  input: z.object({
    ruleId: zExt.objectId(),
    discountMessage: z
      .string()
      .min(1)
      .max(MAX_DISCOUNT_MESSAGE_LENGTH)
      .optional(),
    discount: discountValueSchema.optional(),
    conditions: discountRuleConditionsSchema.optional(),
    typeConfig: discountRuleTypeConfigSchema.optional(),
  }),
  output: z.null(),
};
